import {  useAuth0 } from "@auth0/auth0-react";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const Navbar = ({ filterItem, menuList }) => {
  const { loginWithRedirect, logout, isAuthenticated,user } = useAuth0();

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleSubMenu = (e) => {
    const arrowParent = e.target.parentElement.parentElement;
    arrowParent.classList.toggle("showMenu");
  };
  useEffect(() => {
    function handleClick() {
      window.scrollTo(0, 0);  
    }

    const scrollLinks = document.querySelectorAll('.scroll-link');
    scrollLinks.forEach(link => link.addEventListener('click', handleClick));

    return () => {
      scrollLinks.forEach(link => link.removeEventListener('click', handleClick));
    };
  }, []);

  const navigate = useNavigate();


  function handleClick() {
    navigate('/');
  }
  return (
    <>
      <div className={`sidebar ${isSidebarOpen ? "close" : ""}`}>
      <Link to="/">
    <div className="logo-details">
  
    <i className='bx bx-store'></i>
    
      <span className="logo_name">Desire Store</span>
    </div>
      </Link>
    <ul className="nav-links">

      <li>
        <div className="iocn-link scroll-link">
          <Link to="/">
            <i className='bx bx-collection' ></i>
            <span className="link_name">Products</span>
          </Link>
          <i className='bx bxs-chevron-down arrow' onClick={toggleSubMenu} ></i>
        </div>
        <ul className="sub-menu scroll-link" >
          <li><NavLink className="link_name" to="/">Products</NavLink></li>
          {menuList.map((curElem, index) => {
  return (
    <li key={index}>
      <Link to="/">
        <span onClick={() => filterItem(curElem)}>{curElem}</span>
      </Link>
    </li>
  );
})}
          
        </ul>
      </li>
   
  
  
      <li>
        <Link to="/bookmark">
        <i className='bx bxs-bookmarks'></i>
          <span className="link_name">Bookmarks</span>
        </Link>
        <ul className="sub-menu blank">
          <li><Link className="link_name" to="/">Bookmarks</Link></li>
        </ul>
      </li>
      
      <li>
        <div className="iocn-link scroll-link">
          <Link >
            <i className='bx bx-compass' ></i>
            <span className="link_name">Explore</span>
          </Link>
          <i className='bx bxs-chevron-down arrow' onClick={toggleSubMenu} ></i>
        </div>
 
        <ul className="sub-menu scroll-link" >
          <li><Link className="link_name">Explore</Link></li>
            
              <Link to="/iso-files"><span> ISO Files </span></Link> 
              <Link to="/LinkLibrary"><span> Link librabry </span></Link> 
              <Link to="https://iodized-apron.000webhostapp.com/"><span> URL Shorter</span></Link> 
              <Link to="https://desirestore-23.000webhostapp.com/"><span> File Uploader</span></Link> 
              <Link to="/Resource-Hub"><span> Resource Hub</span></Link> 
              
        </ul>
      </li>
      <li>
        <div className="iocn-link scroll-link">
          <Link >
          
          <i className='bx bxs-network-chart'></i>
            <span className="link_name"> Services</span>
          </Link>
          <i className='bx bxs-chevron-down arrow' onClick={toggleSubMenu} ></i>
        </div>
        <ul className="sub-menu scroll-link" >
          <li><Link className="link_name">Services</Link></li>
          <Link to="/faq"> <span>FAQ</span></Link> 
          <Link to="/user-profile"> <span>User Profile</span></Link> 
          <Link to="/login"> <span>Login</span></Link> 
          
              
        </ul>
      </li>
      <li className="scroll-link">
        <Link to="/contact">
        <i className='bx bxs-envelope'></i>
          <span className="link_name">Contact</span>
        </Link>
        <ul className="sub-menu blank">
          <li><Link className="link_name" to="/contact">Contact</Link></li>
        </ul>
      </li>
      <li className="scroll-link">
        <Link to="/about">
        <i className='bx bxs-book-content'></i>
          <span className="link_name">About</span>
        </Link>
        <ul className="sub-menu blank">
          <li><Link className="link_name" to="/about">About</Link></li>
        </ul>
      </li>
      <li className="scroll-link">
        <Link to="/social-media">
        <i className='bx bxs-conversation'></i>
          <span className="link_name">Social Media</span>
        </Link>
        <ul className="sub-menu blank">
          <li><Link className="link_name" to="/">Social Media</Link></li>
        </ul>
      </li>
      
      <li className="scroll-link">
        <Link to="/developer">
        <i className='bx bx-code-alt'></i>
          <span className="link_name">Developer</span>
        </Link>
        <ul className="sub-menu blank">
          <li><Link className="link_name" to="/developer">Developer</Link></li>
        </ul>
      </li>
 
   {
    
    isAuthenticated ? (
    
    
   <li>
   <div className="profile-details scroll-link">
     <div className="profile-content" >
 
       <img src={user ? user.picture : "images/user.jpg"} alt="profileImg"/>
     </div>
     <div className="name-job">
      <Link to="/user-profile">
       <div className="profile_name">{user ? user.nickname : "Unknown User"}</div></Link>
       <div className="job">Primium User</div>
     </div>
    <i className='bx bx-log-out' onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}  > </i> 
   </div>
   

 </li>
  ):(
    <li >
    <div className="profile-details scroll-link" id="ClickToLogin">
    <Link to={"/user-profile"}>  <div className="profile-content" >
        <img src="images/user.jpg" alt="profileImg"/>
      </div> </Link>
      <div className="name-job"  onClick={() => loginWithRedirect()}>
        <div className="profile_name">Click to Login</div>
        <div className="job">Free User</div>
      </div>
      <i className='bx bx-log-in' >  </i> 
    </div>
  </li>

  )}
</ul>
  </div>
<div className="home-section" >
    <div className="home-content" >
    {isSidebarOpen ? (
      <i className='bx bx-menu' onClick={toggleSidebar}></i>
    ) : (
     
      <i className='bx bx-x' onClick={toggleSidebar}></i>
    )}
      <span className="text">Menu</span>
    <i className='bx bx-left-arrow-alt' onClick={handleClick}></i>
    </div>
  
  </div>
 
    </>
  );
};

export default Navbar;
